/* --------------------------------------------------------------------------------------
   scan.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class scanService {
  /*@ngInject*/
  constructor(
    appSettings,
    xeroxEIPParameters,
    apiClientService,
    workflowScanningService,
    $translate
  ) {
    this.appSettings = appSettings;
    this.apiClientService = apiClientService;
    this.workflowScanningService = workflowScanningService;
    this.xeroxEIPParameters = xeroxEIPParameters;
    this.$translate = $translate;
  }

  async setOptions() {
    this.twoSidedScanOptions = this.xeroxEIPParameters.sides.filter((side) =>
      side.scope.includes("scan")
    );
    this.resolutionOptions = this.xeroxEIPParameters.resolutions;
    this.outputColorOptions = this.xeroxEIPParameters.scanColorModes;
    this.originalTypeOptions = this.xeroxEIPParameters.types;
    this.originalOrientationOptions = this.xeroxEIPParameters.orientations;

    const originalSizeOptionsLoader = this.xeroxEIPParameters.sizes;
    this.originalSizeOptions = originalSizeOptionsLoader;
  }

  async setDefaults() {
    this.twoSidedScan = this.twoSidedScanOptions[0].key;
    this.twoSidedScanText = await this.$translate(
      this.twoSidedScanOptions[0].translationKey
    );

    this.resolution = this.resolutionOptions[4].key;
    this.resolutionText = this.resolutionOptions[4].value;

    this.outputColor = this.outputColorOptions[0].key;
    this.outputColorText = await this.$translate(
      this.outputColorOptions[0].translationKey
    );

    this.originalType = this.originalTypeOptions[0].key;
    this.originalTypeText = await this.$translate(
      this.originalTypeOptions[0].translationKey
    );

    this.originalOrientation = this.originalOrientationOptions[0].key;
    this.originalOrientationText = await this.$translate(
      this.originalOrientationOptions[0].translationKey
    );

    this.originalSize = this.originalSizeOptions[0].key;
    this.originalSizeText = this.originalSizeOptions[0].value;
    this.originalSizeOrientation = this.originalSizeOptions[0].orientation;
  }

  async setDefaultCategory() {
    if (!this.categories)
      this.categories = await this.apiClientService.get("/clio/categories");
    this.category = this.categories[0];
  }

  async setDefaultLanguage() {
    if (!this.languages)
      this.languages = await this.apiClientService.get("/clio/languages");
    this.language = this.languages[0];
    this.searchable = true;
  }

  async scan(profileId, scanFolder, filename) {
    if (!filename) filename = "Xerox Scan [Date & Time].pdf";

    const documentPath =
      scanFolder.ID +
      "/" +
      filename.replace("[Date & Time]", moment().format("YYYYMMDDHHmmss"));
    const scanOptions = this.getScanOptions(scanFolder, documentPath);
    const scanTicket = await this.apiClientService.post(
      "/scan/ticket/" + profileId,
      scanOptions
    );
    const scanJob = await this.workflowScanningService.submitScanTicket(
      scanTicket,
      this.appSettings.deviceUrl
    );
    //TODO: Parsing should be moved to workflowScanningService
    return xrxScanV2ParseInitiateScanJob(scanJob.response);
  }

  getPreviewPageCount(profleId) {
    return this.apiClientService.get("/scan/count/" + profleId);
  }

  getImageUrl(uri) {
    return this.apiClientService.getApiUrl() + uri;
  }

  saveFile(profleId) {
    return this.apiClientService.put("/scan/" + profleId);
  }

  getScanOptions(scanFolder, documentPath) {
    return {
      ParentType: scanFolder.EntryType,
      DocumentPath: documentPath,
      Duplex: this.twoSidedScan,
      Resolution: this.resolution,
      ColorMode: this.outputColor,
      OriginalType: this.originalType,
      Orientation: this.originalOrientation,
      OriginalSize: this.originalSize,
      CategoryID: this.category.ID,
      UserDate: this.date,
      Searchable: this.searchable,
      Language: this.searchable ? this.language : null,
      Archival: this.archival,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/scan/services/scan.service.js